module.exports = __webpack_public_path__ + "static/media/logo8.bfb898e2.png";